// Sentence case, preserving acronym runs: `URLField` → "URL field".
export const humaniseIdentifier = (raw: string): string => {
  const withoutPrefix = raw
    .replace(/^#\/properties\//, '')
    .replace(/^CustomAttributeData\./, '');

  const words = withoutPrefix
    .replace(/[_\-.]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .split(/\s+/)
    .filter(Boolean)
    .map((word) =>
      word.length > 1 && word === word.toUpperCase() ? word : word.toLowerCase()
    );

  if (words.length === 0) {
    return '';
  }

  const [first, ...rest] = words;

  return [first.charAt(0).toUpperCase() + first.slice(1), ...rest].join(' ');
};
